var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.paymentDueByCreditCard > 0)?_c('span',{staticClass:"total"},[_vm._v(" Total to pay "),_c('Price',{attrs:{"value":_vm.paymentDueByCreditCard}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }